import {IInitiatorDetails, initInitiatorDetails} from "./InitiatorDetails";
import {initRequestDetailsItem, RequestDetailsItem} from "./RequestDetailsItem";
import {initRequestPOIInfoItem, RequestPOIInfoItem} from "./RequestPOIInfoItem";
import {List} from "@fluentui/react";
import {EUSectoralLegislatureBasisDto, RecipientAndRequestDto} from "./RecipientAndRequestDto";

export interface IRequestForInfoItem {
    initiatorDetails: IInitiatorDetails;
    personOfInterest: RequestPOIInfoItem;
    requestDetails: RequestDetailsItem;
    statusTypeId: number;
    comment: string;
    postponeDate?: Date;
    isOutgoing: boolean;
    isOnEscalationPeriod: boolean;
    cancelJustification?: string;
    cancelDate?: Date;
    cancelledBy?: string;
    lastStatusTypeId?: number;
}

export interface IRequestForInfoItemError {
    statusCode: number
}

export function initRequestForInfoItem(): IRequestForInfoItem {
    return {
        initiatorDetails: initInitiatorDetails(),
        personOfInterest: initRequestPOIInfoItem(),
        requestDetails: initRequestDetailsItem(),
        statusTypeId: 0,
        comment: '',
        postponeDate: undefined,
        isOutgoing: false,
        isOnEscalationPeriod: false,
    };
}
